<template>
  <div class="value-chain">
    <div class="process-box">
      <div class="chain-item"
           v-for="(item, i) in list"
           :key="i">
        <div style="display: flex">
          <div class="content">
            <template v-if="!disabeld">
              <span class="index">{{i+ 1}}</span>
              <!-- <i class="left el-icon-circle-plus-outline"
                v-if="item.type !== 2 && list.filter(li => li.type === 3).length < 3"
                @click="addItem(i, 3)"></i> -->
              <i class="delete el-icon-delete"
                v-if="item.type !== 1"
                @click="delItem(i)"></i>
              <!-- <i class="right el-icon-circle-plus-outline"
                v-if="item.type !== 3 && list.filter(li => li.type === 2).length < 3"
                @click="addItem(i, 2)"></i> -->
            </template>

            <div class="name">
              <span v-if="nodeField !== 'newUpstreamCompanyName' && disabeld" class="show_index">{{i+ 1}}</span>
              <div v-if="nodeField === 'newUpstreamCompanyName' && disabeld" class="role_index_wrap">
                <span class="role_index">{{i+ 1}}</span>
                <span>{{item.roleName}}</span>
              </div>
              <el-select v-if="nodeField === 'newUpstreamCompanyName' && !disabeld"
                         v-model="item.roleName" class="role" placeholder="角色" size="mini">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-input size="small" 
                        v-model="item[nodeField]" 
                        placeholder="请输入名称"
                        v-if="!disabeld"></el-input>
              <span v-else>{{item[nodeField]}}</span>
            </div>
          </div>
          
          <div class="line"
              v-if="i !== list.length - 1">
            <span class="text" v-if="nodeField === 'newUpstreamCompanyName'">卖</span>
            <i class="el-icon-caret-right"></i>
          </div>
        </div>
      </div>

      <i class="add_btn el-icon-circle-plus-outline"
        v-if="list.length < 6 && !disabeld"
        @click="addItem()"></i>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    nodeField: {
      type: String,
      default: 'newUpstreamCompanyName'
    },
    disabeld: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array
    }
  },
  data () {
    return {
      options: [
        {label: '源头厂家', value: '源头厂家'},
        {label: '贸易公司', value: '贸易公司'},
        {label: '指定代理商', value: '指定代理商'},
        {label: '加工厂', value: '加工厂'},
        {label: '种植养殖户', value: '种植养殖户'},
        {label: '终端', value: '终端'},
        {label: '其他', value: '其他'},
      ],
    }
  },
  methods: {
    addItem () {
      this.list.push({})
    },
    delItem (i) {
      this.list.splice(i, 1)
    }
  }
}
</script>

<style lang="less">
.value-chain{
  padding: 0 0 0 20px;
  font-size: 28px;
  .process-box {
    // margin: 0 auto 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    .add_btn{
      font-size: 20px;
      line-height: 32px;
    }
    .chain-item{
      position: relative;
      padding-top: 60px;
      .settle-type-line{
        position: absolute;
        width: 320px;
        height: 80px;
        border-top: 1px solid #C0C4CC;
        border-left: 1px solid #C0C4CC;
        border-right: 1px solid #C0C4CC;
        top: -80px;
        left: 100px;
        .settle-type{
          margin-top: -80px;
          text-align: center;
          color: #47a5f8;
        }
        .settle-type-text{
          line-height: 36px;
          font-size: 24px;
        }
      }
    }
    .content{
      width: 280px;
      position: relative;
      .index{
        position: absolute;
        top: -36px;
        font-size: 28px;
        left: -20px;
        border: 1px solid #0068B7;
        color: #0068B7;
        border-radius: 50%;
        height: 36px;
        width: 36px;
        line-height: 34px;
        text-align: center;
        font-size: 28px;
      }
      .delete{
        position: absolute;
        top: -32px;
        font-size: 28px;
        cursor: pointer;
        right: 20px;
        color: #F56C6C;
      }
      .left, .middle, .right{
        position: absolute;
        top: -32px;
        font-size: 28px;
        cursor: pointer;
      }
      .left{
        left: 0;
      }
      .middle{
        left: 66px;
        color: #F56C6C;
      }
      .right{
        right: 40px;
      }
    }
    .name {
      line-height: 48px;
      font-size: 28px;
      position: relative;
      width: 280px;
      text-align: center;
      margin-left: -20px;
      span{
        font-size: 28px;
      }
      .role{
        position: absolute;
        top: -64px;
        left: 22px;
        width: 200px;
        .el-input__inner{
          border-top: none;
          border-left: none;
          border-right: none;
          border-radius: 0;
        }
      }
      .role_index_wrap{
        position: absolute;
        top: -48px;
        font-size: 28px;
        width: 100%;
        text-align: center;
        color: #0068B7;
        .role_index{
          border: 1px solid #0068B7;
          border-radius: 50%;
          height: 34px;
          width: 34px;
          display: inline-block;
          line-height: 34px;
          text-align: center;
          font-size: 26px;
          margin-right: 4px;
        }
      }
      .show_index{
        position: absolute;
        top: -40px;
        left: calc(50% - 18px);
        border: 1px solid #0068B7;
        color: #0068B7;
        border-radius: 50%;
        height: 34px;
        width: 34px;
        line-height: 34px;
        text-align: center;
        font-size: 26px;
      }
    }
    .line {
      width: 80px;
      height: 32px;
      margin-left: -20px;
      border-bottom: 1px dashed #47a5f8;
      color: #47a5f8;
      font-weight: bolder;
      text-align: right;
      margin-right: 20px;
      position: relative;
      i {
        margin-top: 19px;
        margin-right: -8px;
      }
      .text{
        position: absolute;
        top: -20px;
        left: 24px;
      }
    }
  }
}

@media screen and (max-width: 1400px) {
  .process-box {
    .line {
      width: 140px;
    }
  }
}
</style>
